import React from 'react';
import { Notice } from './ui';

export default function SuccessfulPop() {
  return (
    <Notice tone="erfolg" title="Dein Projekt war erfolgreich">
      Du hast dein Fundingziel erreicht.
    </Notice>
  );
}
